import { RenderAppropriate } from '../../internals/RenderAppropriate';

import { CardTitle } from './CardTitle';
import { CardBody } from './CardBody';
import { CardFooter } from './CardFooter';
import { groupDisplayName } from '../../utils';
import { CardStyle } from '../../styles/display/card.styles';
import React, { ReactNode, ComponentType } from 'react';

interface CardProps {
    children?: ReactNode;
    component?: ComponentType<any>;
    [key: string]: any;
}

const applyDisplayName = groupDisplayName('Card');

const Card: React.FC<CardProps> & {
    Title?: any;
    Body?: any;
    Footer?: any;
    Style?: any;
} = ({ children, component: Component, ...rest }) => RenderAppropriate(CardStyle, rest, children, Component);

Card.Title = applyDisplayName(CardTitle);
Card.Body = applyDisplayName(CardBody);
Card.Footer = applyDisplayName(CardFooter);
Card.Style = CardStyle;

export { Card };
